import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

export const BulkRebalanceBreadcrumb = () => {
  const { runId } = useParams();
  const { t } = useTranslation(['bulkRebalance']);

  return runId ? t('breadcrumbRun', { runId }) : '';
};
